module.exports = __webpack_public_path__ + "img/logos-2.7b3ba3a.png";